export default __webpack_public_path__ + "static/media/ic_cart_selected.f3106e5d.svg";